import { PartnerReview } from '../components/profile';
import { ApiResponseType } from './api';

export enum ContractComplianceStateEnum {
    ContractCompliance,
    ContractViolation,
}

export enum ReviewType {
    OnboardingReview,
    ProgressReview,
    ExitReview,
    EditReview,
    PartnerReview,
}

export type ReviewRequestType = {
    reviewText: string;
    stars: number;
    contractComplianceState: ContractComplianceStateEnum;
    contractViolationReason: string;
    reviewType: number;
    IsReviewsTermsChecked: boolean;
};

export type CreateReviewRequestType = ReviewRequestType & {
    offerId: string;
};

export type EditReviewRequestType = ReviewRequestType & {
    companyReviewId?: string;
    candidateReviewId?: string;
};

export type ExistingReviewType = {
    id: string;
    reviewText: string;
    stars: {
        value: number;
    };
    contractComplianceState: ContractComplianceStateEnum;
    contractViolationReason: string;
    reviewType: number;
};

export type CompanyReviewType = {
    id: string;
    companyAvatarUrl: string;
    managerId: string;
    companyId: string;
    candidateId: string;
    offerId: string;
    companyName: string;
    date: Date;
    reviewText: string;
    stars: {
        value: number;
    };
    contractComplianceState: ContractComplianceStateEnum;
    replys: reply[];
    reviewType?: number;
    contractViolationReason?: string;
    reviewEditedTimes: number;
    offerState: number;
};

export type CandidateReviewType = {
    id: string;
    candidateAvatarUrl: string;
    candidateFirstName: string;
    candidateLastName: string;
    candidateId: string;
    companyId: string;
    date: Date;
    offerId: string;
    reviewText: string;
    stars: {
        value: number;
    };
    contractComplianceState: ContractComplianceStateEnum;
    replys: reply[];
    reviewType?: number;
    contractViolationReason?: string;
    reviewEditedTimes: number;
    offerState: number;
};

export type CandidateReviewsType = {
    id: string;
    managerId: string;
    candidateId: string;
    companyId: string;
    companyAvatarUrl: string;
    offerId: string;
    companyName: string;
    companyLocation: string;
    date: Date;
    reviewText: string;
    stars: {
        value: number;
    };
    contractComplianceState: ContractComplianceStateEnum;
    candidateReviews: candidateReviews[];
    reviewType: number[];
    contractViolationReason?: string;
    onboardingReviews: candidateReviews[];
    progressReviews: candidateReviews[];
    exitReviews: candidateReviews[];
    CandidateAddress: string;
    isUser?: number;
};

export type candidateReviews = {
    id: string;
    managerId: string;
    companyId: string;
    companyAvatarUrl: string;
    offerId: string;
    companyName: string;
    date: Date;
    reviewText: string;
    suspendStatus: number;
    stars: {
        value: number;
    };
    contractComplianceState: ContractComplianceStateEnum;
    replys: reply[];
    reviewType: number;
    contractViolationReason?: string;
    jobTitle: string;
    jobStartDate: Date;
    reviewEditedTimes: number;
    wasReviewEdited: boolean;
    reviewEditedDate: Date;
    reviewCreatedDate: Date;
    offerType: number;
    offerState: number;
    isUser: number;
};

export type CompanyReviewsType = {
    id: string;
    candidateId: string;
    candidateAvatarUrl: string;
    companyId: string;
    offerId: string;
    candidateFirstName: string;
    candidateLastName: string;
    date: Date;
    reviewText: string;
    stars: number;
    contractComplianceState: ContractComplianceStateEnum;
    companyReviews: CompanyReviews[];
    reviewType: number[];
    contractViolationReason: string;
    jobTitle: string;
    progressReviews: CompanyReviews[];
    onboardingReviews: CompanyReviews[];
    exitReviews: CompanyReviews[];
    partnerReviews: PartnerReview[];
};

export type CompanyReviews = {
    id: string;
    candidateId: string;
    candidateAvatarUrl: string;
    companyId: string;
    offerId: string;
    companyName: string;
    companyAvatarUrl: string;
    candidateFirstName: string;
    candidateLastName: string;
    date: Date;
    reviewText: string;
    suspendStatus: number;
    stars: {
        value: number;
    };
    contractComplianceState: ContractComplianceStateEnum;
    replys: reply[];
    reviewType: number;
    contractViolationReason: string;
    jobTitle: string;
    jobStartDate: Date;
    reviewEditedTimes: number;
    wasReviewEdited: boolean;
    reviewEditedDate: Date;
    reviewCreatedDate: Date;
    offerType: number;
    offerState: number;
};

type reply = {
    id?: string;
    companyReviewId?: string | null;
    candidateReviewId?: string | null;
    candidateFirstName?: string;
    candidateId?: string | null;
    companyId?: string | null;
    candidateLastName?: string;
    replyText?: string;
    companyName?: string | null;
    date?: Date;
    offerId?: string | null;
    reviewId?: string | null;
    replyEditedTimes: number;
    wasReplyEdited: boolean;
    replyEditedDate: Date;
    candidateRepliedTimes: number;
    repliedByRole: number;
    companyRepliedTimes: number;
    suspendStatus: number;
};

export type ReviewsCompanyResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: CompanyReviewsType[];
};

export type PartnerReviewsCompanyResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: PartnerReview[];
};

export type ReviewsCandidateResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: CandidateReviewsType[];
};

export type ReviewResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: ExistingReviewType;
};
